import React, { useState } from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"

const FeedbackDialog = ({ isOpen, onClose, onContinue, texts }) => {
  const [feedback, setFeedback] = useState("")

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="centered"
      className="md:max-w-md"
      closeOnEscape={true}
      title={texts?.feedbackTitle}
    >
      <div className="flex flex-col gap-5">
        <p className="text-sm text-text_secondary mt-0 mb-2">
          {texts?.feedbackSubtitle}
        </p>

        <textarea
          autoFocus
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder={texts?.feedbackPlaceholder}
          className="w-full h-32 resize-none border border-bordered rounded-xl px-4 py-3 text-sm bg-canvas text-text placeholder:text-text_secondary/70 focus:outline-none focus:border-primary transition-colors"
        />

        <div className="flex justify-end">
          <Button
            variant="primary"
            onClick={() => onContinue(feedback)}
            disabled={!feedback.trim()}
          >
            {texts?.next}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default FeedbackDialog
